export default {
  tabMenu: {
    view: 'Układ',
    alarm: 'Alarmy',
    loadList: 'Załaduj listę',
    movements: 'Ruchy',
    gantt: 'Wykres Gantta',
    loadingPlace: 'Miejsce załadunku',
  },
};
